import { createContext, ReactNode, useContext, useMemo, useState } from 'react';

interface ChartCursorContextType {
  cursorPosition: number | null;
  setCursorPosition: (newCursorPosition: number | null) => void;
}

const initialState = {
  cursorPosition: 0,
  setCursorPosition: () => {},
};

const ChartCursorContext = createContext<ChartCursorContextType>(initialState);

interface ChartCursorContextProviderProps {
  children: ReactNode;
}

export const ChartCursorContextProvider = ({ children }: ChartCursorContextProviderProps) => {
  const [cursorPosition, setCursorPosition] = useState<number | null>(0);

  const value = useMemo(() => ({ cursorPosition, setCursorPosition }), [cursorPosition]);

  return <ChartCursorContext.Provider value={value}>{children}</ChartCursorContext.Provider>;
};

export const useChartCursor = () => {
  return useContext(ChartCursorContext);
};
